/* RESPONSIBLE TEAM: team-ai-agent */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { hash } from 'rsvp';

export default class ResolutionBotRoute extends Route {
  @service store;
  @service appService;
  @service intercomEventService;
  @service modalService;
  @service intl;
  @service workflowConnectorInsertableActions;

  titleToken = this.intl.t('operator.sub-menu.fin.title');

  get app() {
    return this.appService.app;
  }

  setupController(controller, model, transition) {
    super.setupController(...arguments);

    let showUpgradeModal =
      transition &&
      transition.to &&
      transition.to.queryParams &&
      transition.to.queryParams.add_answer_bot_modal;
    if (showUpgradeModal) {
      controller.set('launchUpgradeModal', true);
    }
  }

  async model() {
    let findDescriptorPromise = async () => {
      return this.store.findAll('conversation-attributes/descriptor');
    };
    let findCustomObjectsPromise = async () => {
      return this.store.findAll('custom-objects/object-type');
    };

    let findInsertableActionsPromise = async () => {
      return this.workflowConnectorInsertableActions.loadActions();
    };

    let [descriptors, customObjects] = await Promise.all([
      findDescriptorPromise(),
      findCustomObjectsPromise(),
      findInsertableActionsPromise(),
    ]);

    return hash({
      descriptors,
      customObjects,
    });
  }

  resetController(controller) {
    controller.set('launchUpgradeModal', false);
  }

  @action
  didTransition() {
    this.intercomEventService.trackEvent('fin-automation-page-visited');
  }
}
